import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { openNativeOrWeb } from "common/nativeRoute";
import { openMyQuotes } from "common/nativeBridge";
import { RESULT_KEYS, emitResult } from "common/resultKeys";

/**
 * 네이티브 견적 문진 위저드 완료 콜백 수신.
 * 네이티브가 제출 후 window.onQuoteSubmitted() 호출 → 견적 요청 내역으로 이동.
 * 앱은 네이티브 '내 견적요청 목록' 화면, 웹은 /myQuotes 라우팅.
 * BrowserRouter 하위에 렌더되어야 useNavigate 가 동작한다.
 */
export default function NativeQuoteBridge() {
  const navigate = useNavigate();
  useEffect(() => {
    window.onQuoteSubmitted = () => {
      // 견적 상태를 보여주는 화면(강사 상세·레슨 탭 등)도 갱신되게 QUOTES 결과를 함께 뿌린다.
      emitResult(RESULT_KEYS.QUOTES);
      openNativeOrWeb(openMyQuotes, {}, navigate);
    };
    return () => { delete window.onQuoteSubmitted; };
  }, [navigate]);
  return null;
}
